<div class="product-requests">
  <div class="layout-switcher">
    <layout-switcher [layout]="layout.LIST"></layout-switcher>
  </div>
  <div class="constrainer">
    <product-request-list></product-request-list>
  </div>
</div>
